import { render } from "./TaiKhoanSelectionV2.vue?vue&type=template&id=10028c2e&ts=true"
import script from "./TaiKhoanSelectionV2.vue?vue&type=script&lang=ts"
export * from "./TaiKhoanSelectionV2.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__